import { useGetRequestOptions, UseGetRequestOptionsParams } from "./useGetRequestOptions";
import { AutocompleteOption } from "../../../components/SortFilter/interfaces";

/**
	 * This is a shortcut to simply call useGetRequestOptions specifying that the options should be formatted
	 * for use in an autocomplete input, which includes normalizing the options to have `id` and `label` keys
	 *
	 * @param useGetRequestOptionsParams - Configuration for the underlying `useGetRequestOptions` hook
	 * @returns An object containing:
	 * - `options`: an array of normalized `AutocompleteOption` items including the default "All" option;
	 * - `isLoading`: a boolean indicating whether the request is currently in progress;
	 * - `error`: any error returned by the underlying request, or `undefined`/`null` if none.
	 */

const useGetRequestAutocompleteOptions = (useGetRequestOptionsParams: UseGetRequestOptionsParams) => {
  const {
    options,
    isLoading,
    error
  } = useGetRequestOptions({
    ...useGetRequestOptionsParams,
    optionFormat: 'AUTOCOMPLETE'
  });

  return {
    options: options as unknown as AutocompleteOption[],
    isLoading,
    error
  };
}

export { useGetRequestAutocompleteOptions };
